import { callApi } from "@app/api";

export const loadGames = lang =>
  // return callApi('api/games?lang=' + lang, {
  callApi(`games/all/?lang=${lang}`, {
    method: "GET",
    // apiType: 'game',
  });
export const loadGame = token =>
  // return callApi('api/game/?token=' + token, {
  callApi(`games/game/?token=${token}`, {
    method: "GET",
    // apiType: 'game',
  });
export const prepareGame = (id, user_id, token, lang) =>
  // return callApi('api/prepare', {
  callApi("games/prepare/", {
    method: "POST",
    // apiType: 'game',
    type: "JSON",
    body: {
      id,
      user_id,
      token,
      lang,
    },
  });
